import React from 'react';
import vector from '../Assets/Vector-4.png'
import user from '../Assets/Vector-3.png'
import arrow from '../Assets/Group 34.png'

import facebook from '../Assets/Vector-5.png'
import insta from '../Assets/Vector-6.png'
import youtube from '../Assets/Vector-7.png'
import linkedin from '../Assets/Vector-8.png'

export default function About() {
  return (
    <>
    <div className="AboutOuter">
      <div className="left">

    {/* First  */}
        <div className="AboutDetails">
            <h3>
                Read about our blogs for more <br/>
                information on our processes 
            </h3> 
        </div>
        <div className="AboutCard">
            <img src={vector} alt="/"/>
            <h3>
                How to start a company<br/>
                formation in Dubai<br/>
                <span>5 Minutes</span>
            </h3>
        </div>
        <div className="AboutCard">
            <img src={vector} alt="/"/>
            <h3>
                How to start an Offshore <br/>
                company formation in Dubai <br/>
                <span>5 Minutes</span>
            </h3>
        </div>
        <div className="AboutCard">
            <img src={vector} alt="/"/>
            <h3>
                SEO Dubai: Who benefits <br/>
                the most? <br/>
                <span>5 Minutes</span>
            </h3>
        </div>
    {/* Second  */}
    <div className="AboutDetails aboutSecond">
            <h3>
                Satidfied We are When Our <br/>
                Customers Are Happy
            </h3> 
        </div>
        <div className="AboutCardUser">
            <div className="aboutimg">
                <img src={user} alt="/"/>
            </div>
            <p>
                <b>"</b>I am very happy with them. I’ll<br/>
                continue to use their services in<br/>
                future & highly recommend them<br/>
                to anyone,<b>"</b>
                <h3>Muhib Abrar</h3>
            </p>
        </div>
        <div className="AboutCardUser">
            <div className="aboutimg">
                <img src={user} alt="/"/>
            </div>
            <p>
                <b>"</b>Rama has a high level of integrity,<br/> 
                    intellect, knowledge of his <br/>
                    business, resourcefulness and <br/>
                    humanity,<b>"</b>
                <h3>Colin Saldahna</h3>
            </p>
        </div>
        <div className="AboutCardUser">
            <div className="aboutimg">
                <img src={user} alt="/"/>
            </div>
            <p>
                <b>"</b>Your advise was so complete that I <br/>
                    actually realized how beneficial <br/>
                    this would be to my clients and my <br/>
                    business.<b>"</b>
                <h3>Mark Swann</h3>
            </p>
        </div>

      </div>

      <div className="Aboutright">
      <div className="AboutDetails">
            <h3>
                Get to know the whole us and <br/>
                more of our services 
            </h3> 
        </div>
        <div className="Aboutlists">
                <span>Services</span>
            <ul>
                <li>Products</li>
                <li>Solutions</li>
                <li>Assurance</li>
                <li>FAQ</li>
                <li>Working at Varal-Singhania</li>
            </ul>
        </div>
        <div className="Aboutlists">
                <span>Policies</span>
            <ul>
                <li>Privacy Policy</li>
                <li>Terms & Conditions</li>
            </ul>
        </div>
        <div className="Aboutlists">
                <span>About</span>
            <ul>
                <li>About Us</li>
                <li>Contact Us</li>
            </ul>
        </div>
        <div className="Aboutlists">
                <span>Address</span>
            <ul>
                <li>608 One Lake Plaza, Cluster T,</li>
                <li>Al Sarayat Street, Jumeirah</li>
                <li>Lake Towers</li>
                <li>Dubai</li>
                <li>United Arab Emirates</li>
                <br/>
                <li>Office Hours: Sunday to </li>
                <li>Thursday 8:30 AM to 6:30 PM </li>
                <li>[GMT+4]</li>
                <li>M: +971 55 794 2016</li>
                <li>O: +971 4 447 2061</li>
            </ul>
        </div>
        <div className="Aboutlists">
                <span>Subscribe Now</span>
            <ul>
                <li>Sunbscribe now to receive our </li>
                <li>Newsletters about amazing</li>
                <li>opportunities in Dubai</li>
            </ul>
        </div>
        <div className="Email">
            <input type="email" placeholder="Enter email address"/>
            <img src={arrow} alt="/"/>
        </div>
        <div className="Aboutlists "></div>
            <img src={facebook} alt="/" />
            <img src={insta} alt="/" />
            <img src={linkedin} alt="/" />
            <img src={youtube} alt="/" />
      </div>
    </div>
    <div className="footer">
      <p>Varaluae 2021 &copy; All Right Reserved</p>
      </div>
    </>
  );
}
